import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import styled, { css } from 'styled-components';

import {
  InputStyles,
  SharedInputStyles,
} from '@polyai/ui/components/atoms/Input/Input.styled';
import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const LexicalPocWrapper = styled.div`
  position: relative;
`;

export const EditorContainer = styled.div`
  position: relative;

  > div:has(span[id='lexical-placeholder']) {
    pointer-events: none;

    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;

    padding: ${themeSpacing.xs3} ${themeSpacing.sm1};

    font-family: inherit;

    /* Match the input text styling */
    font-size: ${text.size.body.regular};
    font-weight: ${text.weight.regular};
    line-height: ${text.lineHeight.normal};
    color: ${themeColors.textPlaceholder};
  }
`;

export const Editable = styled(ContentEditable)`
  ${InputStyles as any};
  ${SharedInputStyles};
  display: inline-block;

  width: 100%;
  height: 100%;
  min-height: ${sizes.inputHeight};
  padding-right: ${themeSpacing.md1};

  font-weight: ${text.weight.regular};
  white-space: pre-wrap;

  &:focus {
    outline: none;
  }

  &:focus-within {
    border-color: ${themeColors.borderPrimary};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${themeColors.textDisabled};
      background-color: ${themeColors.backgroundPage};
    `};
`;
